import { get, writable } from 'svelte/store';
import { ReportsService } from '../../../services/reports.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const customFieldsSchemas = writable([]);
export const tableCustomFields = writable([]);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function initDetail(oid) {
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function clearSearch() {
    resetSearchFilter();
    search();
}
export function resetSearchFilter() {
    filter.set({ criteria: {}, params: null, sorting: "" });
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ReportsService.getMagazine(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onExport() {
    let _filter = get(filter);
    ReportsService.exportExcelMagazine(_filter);
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
